import React from "react";
import { useSelector } from 'react-redux';
import { change } from 'redux-form';
import Dropzone from "./Dropzone/Dropzone";


const BookingReviewImage = (props) => {
	const {
		postUrl,
		loaderName,
		fieldName,
		formName,
		reviewImages,
		handleDropzone,
		setImageLoader,
		iconClass,
		className
	} = props

	const handleDropzoneImage = (fileName, fieldName, formName) => {
		change(formName, fieldName, fileName)
	};
	const maxUploadSize = useSelector(state => state?.siteSettings?.data?.maxUploadSize)
	return (
		<>
			<Dropzone
				componentConfig={{
					iconFiletypes: ['.jpg', '.png', '.svg'],
					multiple: true,
					showFiletypeIcon: false,
					postUrl
				}}
				loaderName={loaderName}
				fieldName={fieldName}
				formName={formName}
				iconClass={iconClass}
				className={className}
				handleDropzone={handleDropzone ? handleDropzone : handleDropzoneImage}
				isLoader
				reviewImages={reviewImages}
				setImageLoader={setImageLoader}
				maxUploadSize={maxUploadSize}
			/>
		</>
	)
}
export default BookingReviewImage